import React, { useState } from 'react';
import API_BASE from '../apiConfig';
import BackButton from '../components/BackButton';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState('');
  const canSubmit = email.trim().length > 0;

  async function handleSubmit(e) {
    e.preventDefault();
    setErr('');
    try {
      const res = await fetch(`${API_BASE}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      if (!res.ok) {
        const j = await res.json().catch(() => ({}));
        throw new Error(j.error || `HTTP ${res.status}`);
      }
      setSent(true);
    } catch (e) {
      setErr(e.message);
    }
  }

  return (
    <div className="auth-container">
      <BackButton label="Tillbaka" />
      <div
        style={{
          padding: 24,
          borderRadius: 14,
          border: '1px solid #e5e7eb',
          background: '#fff',
          boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 6 }}>
          <div
            aria-hidden
            style={{
              width: 36, height: 36, borderRadius: 999,
              background: '#eff6ff', display: 'grid', placeItems: 'center',
              fontWeight: 600, color: '#1d4ed8'
            }}
          >?</div>
          <h2 style={{ margin: 0, fontSize: 20, lineHeight: '28px' }}>Glömt lösenord</h2>
        </div>
        <p style={{ margin: '2px 0 16px 48px', color: '#6b7280', fontSize: 14 }}>
          Skriv in din e-post så skickar vi en återställningslänk (giltig i ~60 min).
          Kolla skräpkorgen om mailet inte syns.
        </p>

        {sent ? (
          <div
            role="status"
            style={{
              background: '#ecfdf5',
              border: '1px solid #a7f3d0',
              color: '#065f46',
              borderRadius: 10,
              padding: 12,
              marginTop: 8
            }}
          >
            <strong style={{ display: 'block' }}>Länk skickad!</strong>
            <span>Öppna länken i mailet för att välja ett nytt lösenord.</span>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 12 }}>
            <div style={{ display: 'grid', gap: 6 }}>
              <label htmlFor="email" style={{ fontWeight: 500 }}>E-post</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="namn@exempel.se"
                required
                autoComplete="email"
                style={{ height: 40, borderRadius: 10 }}
              />
              <div style={{ color: '#6b7280', fontSize: 12 }}>
                Vi skickar endast en länk – aldrig lösenord via e-post.
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                type="submit"
                className="btn-primary"
                disabled={!canSubmit}
                style={{ height: 36, borderRadius: 8, padding: '0 14px' }}
              >
                Skicka återställningslänk
              </button>
            </div>

            {err && (
              <div
                role="alert"
                style={{
                  background: '#fef2f2',
                  border: '1px solid #fecaca',
                  color: '#b91c1c',
                  borderRadius: 10,
                  padding: 10
                }}
              >
                {err}
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
}
